import React from 'react';
import './CooperationPage.css';
import { Link } from 'react-router-dom';
import { TeamOutlined, SendOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Flex from '../../components/Flex/Flex';
import Text from '../../components/Text/Text';
import SupportIcon from '../../assets/Icons/SupportIcon.svg?react';

const MANAGER_TELEGRAM_URL = 'https://t.me/fishh_support';

const AUDIENCE_KEYS = [
  'cooperation_audience_coach',
  'cooperation_audience_school',
  'cooperation_audience_fund',
  'cooperation_audience_streamer',
  'cooperation_audience_blogger',
  'cooperation_audience_affiliate',
] as const;

const CooperationPage = React.memo(() => {
  const { t } = useTranslation('translation');

  return (
    <div className="PageShell CooperationPage">
      <header className="PageHero">
        <div className="PageHero__glow" aria-hidden />
        <Flex vertical gap={12} className="PageHero__content">
          <span className="PageHero__eyebrow">
            <TeamOutlined /> Fish Hunter
          </span>
          <Text size={6} bold>
            {t('cooperation_title')}
          </Text>
          <Text type="secondary" size={3}>
            {t('cooperation_hero_subtitle')}
          </Text>
        </Flex>
      </header>

      <section className="PageSection">
        <Text size={4}>{t('cooperation_intro')}</Text>
        <div className="CooperationPage__audience">
          {AUDIENCE_KEYS.map((key) => (
            <span key={key} className="CooperationPage__audience-tag">
              {t(key)}
            </span>
          ))}
        </div>

        <div className="SurfaceCard CooperationPage__offer">
          <Text size={4} bold>
            {t('cooperation_offer_title')}
          </Text>
          <Text type="secondary" size={3}>
            {t('cooperation_offer_text')}
          </Text>
        </div>
      </section>

      <section className="SurfaceCta CooperationPage__cta">
        <span className="CooperationPage__cta-icon">
          <SupportIcon />
        </span>
        <Flex vertical gap={8} flex>
          <Text size={4} bold>
            {t('cooperation_cta_title')}
          </Text>
          <Text type="secondary">
            {t('cooperation_cta_prefix')}{' '}
            <Link
              className="CooperationPage__link"
              target="_blank"
              rel="noopener noreferrer"
              to={MANAGER_TELEGRAM_URL}
            >
              {t('cooperation_cta_manager')}
            </Link>{' '}
            {t('cooperation_cta_suffix')}
          </Text>
        </Flex>
        <Link
          className="CooperationPage__telegram-btn"
          target="_blank"
          rel="noopener noreferrer"
          to={MANAGER_TELEGRAM_URL}
        >
          <SendOutlined />
          {t('cooperation_cta_button')}
        </Link>
      </section>
    </div>
  );
});

export default CooperationPage;
